import React__default from 'react';
import 'classnames';
import { CloseStroke } from '../../../../assets/icons/CloseStroke.esm.js';
import 'tslib';
import styles from './CloseButton.module.esm.js';

var CloseButton = function (_a) {
    var ariaLabel = _a.ariaLabel, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement("button", { "aria-label": ariaLabel, className: "".concat(styles.root, " ").concat(className), onClick: onClick, type: "button" },
        React__default.createElement(CloseStroke, { className: styles.icon })));
};

export { CloseButton, CloseButton as default };
//# sourceMappingURL=CloseButton.esm.js.map
